import { request } from "./http";
import type { InsuranceProvider, InsurancePaymentBatch } from "../types";

export const listInsuranceProviders = () =>
  request<InsuranceProvider[]>("/api/company/insurance-providers");

export const createInsuranceProvider = (body: { name: string }) =>
  request<InsuranceProvider>("/api/company/insurance-providers", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const updateInsuranceProvider = (id: number, body: { name: string }) =>
  request<InsuranceProvider>(`/api/company/insurance-providers/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const deleteInsuranceProvider = (id: number) =>
  request<void>(`/api/company/insurance-providers/${id}`, { method: "DELETE" });

export const listInsuranceBatches = () =>
  request<InsurancePaymentBatch[]>("/api/insurance-batches");

export const createInsuranceBatch = (body: {
  insurance_provider_id: number;
  total_amount_cents: number;
  payment_ids: number[];
  paid_at?: string;
  notes?: string;
  payment_amounts?: { payment_id: number; amount_cents: number }[];
}) =>
  request<InsurancePaymentBatch>("/api/insurance-batches", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const getInsuranceBatch = (id: number) =>
  request<InsurancePaymentBatch & { payments: any[] }>(`/api/insurance-batches/${id}`);